<!-- 签到 -->
<template>
    <div>
      <div class="course_SignIn">
        <el-row>
          <label>签到状态：</label>
          <el-select clearable v-model="status" filterable placeholder="请选择">
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
          <el-button type="success" icon="el-icon-search" @click="getInfo(page = 1)">搜索</el-button>
        </el-row>
        <el-row class="content_block mt20">
          <el-row>
            <el-table
              :data="tableData"
              border
              style="width: 100%">
              <el-table-column type="index" header-align="center" align="center" width="100" label="序号"></el-table-column>
              <el-table-column prop="teacherOpenCourseStudentSigninSettingSigninTime" header-align="center" align="center" label="签到日期">
                <template v-slot="scope">
                  <template v-if="scope.row.teacherOpenCourseStudentSigninLogTag =='20' || scope.row.teacherOpenCourseStudentSigninSettingType =='manual_signin'">
                    -
                  </template>
                  <template v-else>
                    {{scope.row.teacherOpenCourseStudentSigninSettingSigninTime}}
                  </template>
                </template>
              </el-table-column>
              <el-table-column prop="teacherOpenCourseStudentSigninSettingTypeText" header-align="center" align="center" label="签到方式"> </el-table-column>
              <el-table-column prop="teacherOpenCourseStudentSigninSettingStartTime" header-align="center" align="center" label="开始签到时间"> </el-table-column>
              <el-table-column prop="teacherOpenCourseStudentSigninSettingEndTime" header-align="center" align="center" label="结束签到时间"> </el-table-column>
              <el-table-column prop="teacherOpenCourseStudentSigninSettingStatusText" header-align="center" align="center" label="状态">
                <template v-slot="scope">
                  <span :class="scope.row.teacherOpenCourseStudentSigninSettingStartStatus == 'ING'?'primary':scope.row.teacherOpenCourseStudentSigninSettingStartStatus == 'READY'?'mainWeak':'red'">
                    {{scope.row.teacherOpenCourseStudentSigninSettingStartStatus == 'ING'?"进行中":scope.row.teacherOpenCourseStudentSigninSettingStartStatus == 'READY'?"未开始":"已结束"}}
                  </span>
                </template>
              </el-table-column>
              <el-table-column prop="teacherOpenCourseStudentSigninLogTagText" header-align="center" align="center" label="是否签到">
                <template slot-scope="scope">
                  <!-- SIGN_IN（签到）或者UN_SIGN_IN（缺勤） -->
                  <el-link type="primary" v-if="scope.row.teacherOpenCourseStudentSigninLogTag =='10'" :underline="false">已签到</el-link>
                  <el-link type="danger" v-if="scope.row.teacherOpenCourseStudentSigninLogTag =='20'" :underline="false">缺勤</el-link>
                  <span style="color: #a7a7a7;" v-if="scope.row.teacherOpenCourseStudentSigninLogTag == null || scope.row.teacherOpenCourseStudentSigninLogTag ==''">未签到</span>
                </template>
              </el-table-column>
              <el-table-column prop="user_" header-align="center" align="center" label="操作">
                <template slot-scope="scope">
                  <template v-if='scope.row.teacherOpenCourseStudentSigninSettingStartStatus == "ING" && ($isEmpty(scope.row.teacherOpenCourseStudentSigninLogTag) || scope.row.teacherOpenCourseStudentSigninLogTag == "20")'>
                    <el-link type="primary" :underline="false" @click="startSignIn(scope.row)">开始签到</el-link>
                  </template>
                  <template v-else>
                    -
                  </template>
                </template>
              </el-table-column>
            </el-table>
            <div class="block" style="text-align: right;bottom: 0;width: 96%;margin: 20px;">
              <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page.sync="page"
                :page-sizes="[8, 20, 50, 100]"
                :page-size="limit"
                background
                :hide-on-single-page="true"
                layout="sizes, prev, pager, next,jumper"
                :total="total">
              </el-pagination>
            </div>
          </el-row>
        </el-row>

        <!-- 签到对话框 -->
        <el-dialog
          title="开始签到"
          :visible.sync="show_sigin_in"
          width="500px"
        >
          <span slot="title">
            <i class="el-icon-date" style="margin-right: 10px;color: #f9c75a;"></i>开始签到
          </span>
          <el-row class="mb40">
            <p>请输入验证码：</p>
            <el-input v-model="siginInNo" placeholder="请输入 3位数字+3位小写字母 的验证码"></el-input>
          </el-row>
          <span slot="footer" class="dialog-footer">
            <el-button @click="show_sigin_in = false">取 消</el-button>
            <el-button type="primary" @click="submitSiginIn">确认签到</el-button>
          </span>
        </el-dialog>
      </div>
    </div>
</template>
<script>
export default {
  name: 'SignIn',
  props: {
    courseId: { //课程ID
      type: String,
      required:true
    }
  },
  data() {
    return {
      options: [
        // {
        //   value: '',
        //   label: '未签到'
        // },
      {
        value: 'SIGN_IN',
        label: '已签到'
      }, {
        value: 'UN_SIGN_IN',
        label: '缺勤'
      }],
      status: '',
      tableData:[],

      total: 0,
      limit:8,
      page:1,
      show_sigin_in:false,
      siginInNo:"",
      onTeacherOpenCourseStudentSigninSettingId:"" //当前操作的签到信息ID
    }
  },
  created() {
    this.getInfo();
  },
  mounted() {
  },
  methods: {
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
      this.limit = val;
      this.getInfo();
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.page = val;
      this.getInfo();
    },
    getInfo(){ //获取签到数据
      let param = {
        limit:this.limit,
        page:this.page,
        teacherOpenCourseStudentSigninLogTag:this.status,
        teacherOpenCourseId:this.courseId
      }
      this.$post("/api/teacherOpenCourseStudentSigninSetting/getPageList.do",param).then((ret) =>{
        if(ret.code == 0){
          this.total = Number(ret.count);
          this.tableData = ret.data;
        }else{
          this.$message({message: ret.msg,type: 'error'});
        }
      });
    },
    startSignIn(item){ //开始签到 IP签到、手动签到、验证码签到 ip_signin, manual_signin, code_signin;
      if(item.teacherOpenCourseStudentSigninSettingType != "code_signin"){
        let param = {
          teacherOpenCourseStudentSigninSettingId:item.teacherOpenCourseStudentSigninSettingId,
          teacherOpenCourseStudentSigninLogType:item.teacherOpenCourseStudentSigninSettingType
        }
        this.submitInfo(param);
      }else{
        this.onTeacherOpenCourseStudentSigninSettingId = item.teacherOpenCourseStudentSigninSettingId;
        this.siginInNo = "";
        this.show_sigin_in = true;
      }
    },
    submitSiginIn(){ //提交签到
      if(this.$isEmpty(this.siginInNo)){
        this.$message({message: '请输入验证码！',type: 'warning'});
        return;
      }
      let param = {
        verificationCode:this.siginInNo,
        teacherOpenCourseStudentSigninLogType:"code_signin",
        teacherOpenCourseStudentSigninSettingId:this.onTeacherOpenCourseStudentSigninSettingId
      }
      this.submitInfo(param);
    },
    submitInfo(param){ //提交数据
      this.$post("/api/teacherOpenCourseStudentSigninLog/signin.do",param).then((ret) =>{
        if(ret.code == 0){
          this.getInfo();
          this.show_sigin_in = false;
          this.$message({message: '签到成功！',type: 'success'});
        }else{
          this.$message({message: ret.msg,type: 'error'});
        }
      });

    }
  }
};
</script>
<style  lang="less">
  .course_SignIn{
    padding: 20px;
    border: 1px solid #DEDEDE;
    .content_block{
      background-color: #ffffff;
      .title_img{
        width: 20px;
      }
      .class_img{
        float: left;margin-right: 10px;
      }
      .echarts_row{
        padding: 20px;
      }
      .block_time{
        display: initial;
        margin-left: 20px;
      }
      .el-calendar__body{
        th{
          border-top: 1px solid #E5E5E5;
          border-left: 1px solid #E5E5E5;
          background-color: #EFF2F7;
        }
        th:last-child{
          border-right: 1px solid #E5E5E5;
        }
      }
    }
  }

</style>



// WEBPACK FOOTER //
// src/pages/course/components/SignIn.vue